import React from 'react';
import './Clientes-Modal.css'; // Asegúrate de que este CSS contenga los estilos mejorados
import paneles_ from './assets/Humilladero/image.png';
import Video from './assets/Humilladero/Video.mp4';

//import inversor from './assets/Humilladero/inversor.jpeg';
//import tarjeta from './assets/Humilladero/contilde.png';

const Humilladero = () => {
  return (
    <div className="container">
      <h2>
           ✅ Proyecto: Santuario del Señor del Humilladero🌞✨{' '}
       
      </h2>

       <video controls>
             <source src={Video} type="video/mp4" />
             Tu navegador no soporta la reproducción de video.
           </video>
     

      <p>
         <span className="highlight"> Un lugar de fe que ahora también inspira sostenibilidad: energía limpia al servicio de la comunidad y del medio ambiente.</span>

<br/><br/>En el Santuario del Señor del Humilladero, uno de los templos más representativos y de mayor asistencia espiritual en la ciudad, instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 14.2 kWp, conformado por 20 paneles solares de alta eficiencia y un inversor multicanal de 15 kW.

<br/><br/>Esta tecnología permite gestionar de manera estable y segura la energía eléctrica, optimizando el rendimiento del sistema y garantizando energía constante para iluminación, equipos de sonido y actividades pastorales.

<br/><br/>Los objetivos de este proyecto fueron:

<br/><br/>✔ Reducir los costos asociados al consumo eléctrico del Santuario.
<br/>✔ Implementar una solución sostenible y alineada con el cuidado de la Creación.
<br/>✔ Garantizar energía continua para las actividades religiosas y comunitarias.

<br/><br/>Hoy, el Santuario del Señor del Humilladero genera su propia energía limpia, disminuyendo el costo mensual de facturación eléctrica y destinando esos recursos a otras necesidades pastorales y sociales.

<br/><br/>Esta instalación convierte al Santuario en un ejemplo de compromiso espiritual y responsabilidad ambiental, integrando fe, tecnología y sostenibilidad.

  <span className="highlight"><br/><br/>Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:</span>

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo.
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética.
<br/>🔧 Instalación estructural segura, diseñada para prolongar la vida útil del sistema y facilitar su mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.


<br/><br/>Una decisión inteligente que une sostenibilidad, ahorro y propósito en la fe.
      </p>
 <div className="video-responsive">
        <iframe
          src="https://www.youtube.com/embed/FY6OhR3H2PA"
          title="Testimmonio Palacio Arzobispal"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      

      <figure>
      <img
            src={paneles_}
            alt="Instalación en progreso en la parroquia El Señor de Humilladero"
          />
      </figure>
    </div>
  );
};

export default Humilladero;